import { Link } from 'react-router-dom';

const homeServiceTags = ['HVAC', 'Plumbing', 'Roofing', 'Electrical'];
const solarTags = ['Residential Solar', 'Commercial Solar'];

const homeServiceFeatures = [
  'Capture urgent service call leads 24/7',
  'Auto-schedule dispatch and maintenance visits',
  'Follow up on estimates until signed',
  'Coordinate technicians with real-time updates',
];

const solarFeatures = [
  'Book consultation appointments automatically',
  'Nurture long-cycle solar leads with sequences',
  'Follow up on financing discussions',
  'Track proposals through the sales pipeline',
];

export default function IndustriesSection() {
  return (
    <section className="bg-[#F5F5F7] py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="text-[#6E6E73] text-sm font-semibold uppercase tracking-widest mb-5">
            Industries
          </p>
          <h2 className="text-5xl lg:text-6xl font-extrabold text-[#0A0A0A] leading-none tracking-tighter">
            Built for the businesses
            <br />
            <span className="text-[#6E6E73] font-light">that keep America running.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {/* Home Services card */}
          <div className="bg-white rounded-3xl overflow-hidden group">
            <div
              className="h-56 bg-cover bg-center relative"
              style={{
                backgroundImage:
                  "url('https://public.readdy.ai/ai/img_res/87f5ad6a401c33de336b4fab2f9bd30b.jpg')",
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <div className="absolute bottom-4 left-6 flex flex-wrap gap-2">
                {homeServiceTags.map((tag) => (
                  <span key={tag} className="bg-white/20 backdrop-blur-sm text-white text-xs font-medium px-3 py-1 rounded-full border border-white/20">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-[#0A0A0A] text-2xl font-bold mb-3 tracking-tight">
                Home Services
              </h3>
              <p className="text-[#6E6E73] text-base leading-relaxed mb-6">
                Designed for contractors who rely on fast response times. Our systems answer
                every call, dispatch every tech, and follow up on every estimate.
              </p>
              <ul className="space-y-2 mb-6">
                {homeServiceFeatures.map((f) => (
                  <li key={f} className="flex items-center gap-3 text-sm text-[#1D1D1F]">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#0A0A0A] text-xs font-bold" />
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/industries" className="whitespace-nowrap inline-flex items-center gap-2 text-[#0A0A0A] text-sm font-semibold hover:gap-3 transition-all cursor-pointer">
                Learn more <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          {/* Solar card */}
          <div className="bg-[#0F172A] rounded-3xl overflow-hidden group">
            <div
              className="h-56 bg-cover bg-center relative"
              style={{
                backgroundImage:
                  "url('https://readdy.ai/api/search-image?query=solar%20panel%20installation%20crew%20working%20on%20residential%20rooftop%20under%20bright%20blue%20sky%2C%20professional%20technicians%20wearing%20safety%20harnesses%2C%20clean%20energy%20home%20improvement%2C%20suburban%20neighborhood%2C%20bright%20daylight%20professional%20photography&width=600&height=400&seq=solar-svc-01&orientation=landscape')",
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/70 to-transparent" />
              <div className="absolute bottom-4 left-6 flex flex-wrap gap-2">
                {solarTags.map((tag) => (
                  <span key={tag} className="bg-amber-500/20 backdrop-blur-sm text-amber-300 text-xs font-medium px-3 py-1 rounded-full border border-amber-500/30">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="p-8">
              <h3 className="text-white text-2xl font-bold mb-3 tracking-tight">
                Solar Companies
              </h3>
              <p className="text-white/55 text-base leading-relaxed mb-6">
                Built for longer sales cycles and consultation-based selling. Automation keeps
                every deal alive through financing conversations and multi-month timelines.
              </p>
              <ul className="space-y-2 mb-6">
                {solarFeatures.map((f) => (
                  <li key={f} className="flex items-center gap-3 text-sm text-white/70">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-amber-400 text-xs" />
                    </div>
                    {f}
                  </li>
                ))}
              </ul>
              <Link to="/industries" className="whitespace-nowrap inline-flex items-center gap-2 text-amber-400 text-sm font-semibold hover:gap-3 transition-all cursor-pointer">
                Learn more <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
